/**
 * Contadores de "Experiência comprovada" (snippets/marcos-vendas.liquid).
 *
 * Só dispara quando o marco entra na viewport e nunca reanima. O DOM já
 * nasce com o valor final vindo dos metafields, então sem JS (ou com
 * prefers-reduced-motion) o número correto continua visível — a animação é
 * enfeite, não a fonte do dado.
 *
 * Virou asset (era {% javascript %} da section) quando os contadores
 * passaram a ser um snippet compartilhado: `{% javascript %}` não é
 * suportado em snippet, e um módulo com src roda uma vez por página mesmo
 * que dois consumidores o referenciem.
 */
const DURACAO = 1400;

const animar = (elemento) => {
  const alvo = parseInt(elemento.dataset.marcoAlvo, 10);
  if (!Number.isFinite(alvo)) return;

  const inicio = performance.now();
  const passo = (agora) => {
    const progresso = Math.min((agora - inicio) / DURACAO, 1);
    // easeOutExpo: acelera na largada e assenta no valor final
    const suave = progresso === 1 ? 1 : 1 - Math.pow(2, -10 * progresso);
    elemento.textContent = String(Math.round(alvo * suave));
    if (progresso < 1) requestAnimationFrame(passo);
  };

  elemento.textContent = '0';
  requestAnimationFrame(passo);
};

const preparar = (raiz) => {
  const valores = raiz.querySelectorAll('.marcos-vendas__valor:not([data-marco-pronto])');
  if (!valores.length) return;

  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  valores.forEach((valor) => {
    valor.dataset.marcoPronto = 'true';
    if (semMovimento || typeof IntersectionObserver === 'undefined') return;

    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          observador.disconnect();
          animar(entrada.target);
        });
      },
      { threshold: 0.4 }
    );

    observador.observe(valor);
  });
};

preparar(document);
document.addEventListener('shopify:section:load', (evento) => preparar(evento.target));
